import { Store } from "../redux/store";
import { showWarning, showSuccess } from '../redux/actions/snackbarActions'
import { post, handleErrors, get } from "./requests";
import { URL_BASE } from "./constants";

export async function getReviews(stars, recommend, pageIndex = 0, pageSize = 10) {
    try {
      let url = `${URL_BASE}/review?pageIndex=${pageIndex}&pageSize=${pageSize}`;
      const token = Store.getState().authState.loggedUser;
  
      if (stars) {
        url += `&stars=${stars}`;
      }
      if (recommend) {
        url += `&recommend=${recommend}`;
      }

      const response = await get(url, null, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
      const mappedReviews = response.data.items.map(item => ({
        id: item.id,
        idDemand: item.idDemand,
        observations: item.observations,
        stars: item.stars,
        recommend: item.recommend
      }));
      return mappedReviews;
    } catch (error) {
      throw error;
    }
  }

export default {
    getReviews
}